import Tooltip from "@mui/material/Tooltip";
import { Info } from "lucide-react";
import { TranslatedText } from "@/components/common/text";

export const InfoButton = ({ text, element }) => {
    return (
        <Tooltip title={element || <TranslatedText>{text}</TranslatedText>} arrow>
            <Info className="w-[18px] h-[18px] text-cm-text-tertiary" />
        </Tooltip>
    );
};
